import { IBaseDrugRna } from '@patsnap/synapse_common_interface'
import { IVueI18n } from 'vue-i18n'
import {
  BDrugRnaDeliverySystem,
  BDrugRnaGeneticMaterial,
  BDrugRnaPairedRegion,
  BDrugRnaRegulationMechanism,
  BDrugRnaTargetTissues,
  BDrugRnaTechPlatform,
} from './BDrugRnaField'

export function getDrugRnaRenderContentList(data: IBaseDrugRna, $i18n: IVueI18n) {
  return [
    {
      label: $i18n.tc('synapse_i18n.drug.rna.deliverySystem'),
      content: BDrugRnaDeliverySystem,
      invalid: (data: IBaseDrugRna) => {
        return !data.delivery_system_view
      },
    },
    {
      label: $i18n.tc('synapse_i18n.drug.rna.targetedTissues'),
      content: BDrugRnaTargetTissues,
      invalid: (data: IBaseDrugRna) => {
        return !data.targeted_tissue_view
      },
    },
    {
      label: $i18n.tc('synapse_i18n.drug.rna.targetedRegion'),
      content: BDrugRnaPairedRegion,
      invalid: (data: IBaseDrugRna) => {
        return !data.paired_region_view
      },
    },
    {
      label: $i18n.tc('synapse_i18n.drug.rna.regulationMechanism'),
      content: BDrugRnaRegulationMechanism,
      invalid: (data: IBaseDrugRna) => {
        return !data.regulation_type_view
      },
    },
    {
      label: $i18n.tc('synapse_i18n.drug.rna.geneticMaterial'),
      content: BDrugRnaGeneticMaterial,
      invalid: (data: IBaseDrugRna) => {
        return !data.genetic_material_view
      },
    },
    {
      label: $i18n.tc('synapse_i18n.drug.rna.techPlatform'),
      content: BDrugRnaTechPlatform,
      invalid: (data: IBaseDrugRna) => {
        return !data.tech_platform_view
      },
    },
  ].map((item) => ({ ...item, label: `${item.label}${$i18n.locale.toUpperCase() === 'CN' ? '：' : ': '}` }))
}
